import { useState, useEffect } from "react";
import { FaBars, FaTimes, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { LOCATION_LIST } from "../data/locations";
import { useSelectedLocation } from "../context/LocationContext";

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { location: activeLocation, locationId, setLocationId } =
    useSelectedLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about-us" },
    { label: "Menu", href: "/menu" },
    { label: "Cakes", href: "/cakes" },
    { label: "Gallery", href: "/gallery" },
    { label: "Decorations", href: "/decorations" },
    { label: "Contact Us", href: "/contact-us" },
  ];

  return (
    <div className="sticky top-0 z-50">
      {/* Utility bar */}
      <div className="bg-ink text-gray-300 text-xs sm:text-sm">
        <div className="container mx-auto px-4 py-2 flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-1">
            <FaMapMarkerAlt className="text-primary" />
            <div className="flex rounded-full bg-white/10 p-0.5">
              {LOCATION_LIST.map((loc) => (
                <button
                  key={loc.id}
                  onClick={() => setLocationId(loc.id)}
                  className={`px-3 py-1 rounded-full font-medium transition-colors duration-200 ${
                    locationId === loc.id
                      ? "bg-primary text-ink"
                      : "text-gray-300 hover:text-white"
                  }`}
                >
                  {loc.name}
                </button>
              ))}
            </div>
          </div>
          <a
            href={activeLocation.phoneHref}
            className="flex items-center gap-2 font-medium text-white hover:text-primary transition-colors"
          >
            <FaPhoneAlt className="text-primary" />
            {activeLocation.phoneDisplay}
          </a>
        </div>
      </div>

      {/* Main nav */}
      <nav
        className={`w-full bg-ink/95 backdrop-blur-sm transition-shadow duration-300 ${
          isSticky ? "shadow-lg shadow-black/30" : ""
        }`}
      >
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <Link to="/">
              <div className="flex items-center">
                <img
                  src="/images/secondhome_logo.png"
                  className="w-14"
                  alt="Logo"
                />
              </div>
            </Link>
            <div className="hidden lg:flex items-center space-x-7">
              {navLinks.map((link, index) => {
                const isActive = location.pathname === link.href;
                return (
                  <Link key={index} to={link.href}>
                    <span
                      className={`text-sm uppercase font-medium tracking-wide transition-colors duration-300 pb-1 border-b-2 ${
                        isActive
                          ? "border-primary text-primary"
                          : "border-transparent text-white hover:text-primary"
                      }`}
                    >
                      {link.label}
                    </span>
                  </Link>
                );
              })}
              <Link to="/contact-us">
                <button className="bg-primary hover:bg-primary-dark text-ink font-semibold py-2 px-5 rounded-full text-sm transition-colors duration-300 transform hover:scale-105">
                  Book A Table
                </button>
              </Link>
            </div>

            <button
              className="lg:hidden text-white focus:outline-none text-xl"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-white/10 pt-4">
              {navLinks.map((link, idx) => (
                <Link key={idx} to={link.href} onClick={() => setIsMenuOpen(false)}>
                  <span className="block text-white hover:text-primary py-2 text-sm uppercase tracking-wide">
                    {link.label}
                  </span>
                </Link>
              ))}
              <Link to="/contact-us" onClick={() => setIsMenuOpen(false)}>
                <button className="mt-3 w-full bg-primary hover:bg-primary-dark text-ink font-semibold py-2 px-4 rounded-full text-sm transition-colors duration-300">
                  Book A Table
                </button>
              </Link>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Header;
